import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-results',
  templateUrl: './no-results.component.html',
  styleUrls: ['./no-results.component.css']
})
export class NoResultsComponent  {

  @Input() isRequestSuccess: boolean = true;
  @Input() length: number = 0;
  @Input() message: string = 'No se han encontrado resultados.';

  constructor() { }


}
